import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
  standalone: true,
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: any) {
    // Safe: HTML is sanitized and managed by trusted CMS administrators.

    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
